import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const adminGetEmployee = ({ groupId, userId }) =>
  call(websocketFetch, 'admin_get_employee', {
    group_id: groupId,
    user_id: userId,
    version: 2,
  });
